import styled from "styled-components"

const CustomCheckbox = styled.input`
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  margin: 0;
  width: 24px;
  height: 24px;
  border: 3px solid #616161;
  border-radius: 3px;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
  cursor: pointer;

  :hover {
    filter: opacity(0.6);
  }

  ::before {
    content: "";
    width: 12px;
    height: 12px;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    background-color: #616161;
    transform-origin: bottom left;
    border-radius: 1px;
  }

  :checked::before {
    transform: scale(1);
  }
`

export default CustomCheckbox
